import React from 'react';
import { DownloadIcon, BrainIcon, ZapIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="py-16 px-4 bg-zinc-950 border-t border-gold-900/20" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="text-center mb-12" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-serif" data-id="element-105">
            Your Path to Unbreakable Courage
          </h2>
          <p className="text-gold-500 font-mono uppercase tracking-widest" data-id="element-106">
            In just 15 minutes a day...
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-107">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-gold-700/50 to-transparent z-0" data-id="element-108"></div>

          {/* Step 1 */}
          <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-109">
            <div className="w-24 h-24 rounded-full glass-card flex items-center justify-center mb-6 group-hover:border-gold-500/50 group-hover:shadow-[0_0_30px_rgba(201,168,76,0.2)] transition-all duration-500 relative" data-id="element-110">
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold-500 text-gold-950 font-bold flex items-center justify-center text-sm shadow-lg" data-id="element-111">
                1
              </div>
              <DownloadIcon className="w-10 h-10 text-gold-600 group-hover:text-gold-400 transition-colors" data-id="element-112" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3 font-serif" data-id="element-113">
              Instant Download
            </h3>
            <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-114">
              Get the PDF optimized for any device immediately after your secure
              purchase. Instant access.
            </p>
          </div>

          {/* Step 2 */}
          <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-115">
            <div className="w-24 h-24 rounded-full glass-card flex items-center justify-center mb-6 group-hover:border-gold-500/50 group-hover:shadow-[0_0_30px_rgba(201,168,76,0.2)] transition-all duration-500 relative" data-id="element-116">
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold-500 text-gold-950 font-bold flex items-center justify-center text-sm shadow-lg" data-id="element-117">
                2
              </div>
              <BrainIcon className="w-10 h-10 text-gold-600 group-hover:text-gold-400 transition-colors" data-id="element-118" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3 font-serif" data-id="element-119">
              Strategic Immersion
            </h3>
            <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-120">
              Read the warning and understand the patterns of what's coming.
              Prepare your mind for reality.
            </p>
          </div>

          {/* Step 3 */}
          <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-121">
            <div className="w-24 h-24 rounded-full glass-card flex items-center justify-center mb-6 group-hover:border-gold-500/50 group-hover:shadow-[0_0_30px_rgba(201,168,76,0.2)] transition-all duration-500 relative" data-id="element-122">
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold-500 text-gold-950 font-bold flex items-center justify-center text-sm shadow-lg" data-id="element-123">
                3
              </div>
              <ZapIcon className="w-10 h-10 text-gold-600 group-hover:text-gold-400 transition-colors" data-id="element-124" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3 font-serif" data-id="element-125">
              Conscious Action
            </h3>
            <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-126">
              Apply the principles of civic courage in your daily life. Become
              the beacon of your community.
            </p>
          </div>
        </div>
      </div>
    </section>;
}